import styled from 'styled-components';
import { Scrollbar } from '../../atoms/Scrollbar';

export const Wrapper = styled.div`
  overflow-y: auto;
  ${Scrollbar.secondary}

  .DraftEditor-root {
    margin: 13px 8px;
  }
`;

export const LabelBackground = styled.div`
  position: absolute;
  width: 100%;
  height: 50%;
  bottom: 0;
  left: 0;
  z-index: -1;
`;

export const Label = styled.span<{ atTop?: boolean; disabled?: boolean }>`
  transition: color 0.1s ease;
  position: absolute;
  color: ${({ theme }) => theme.colors.textGrey};
  font-size: ${({ atTop }) => (atTop ? '12px' : '13px')};
  transform: ${({ atTop }) =>
    atTop ? 'translateY(-13px)' : 'translateY(12px)'};
  padding: 0 8px;
  left: 0.5rem;
  transition: transform 0.1s, font-size 0.1s;

  & > ${LabelBackground} {
    background-color: ${({ disabled, theme }) =>
      disabled ? theme.colors.lightestGray : theme.colors.white};
  }
`;

export const Container = styled.div<{ disabled: boolean }>`
  position: relative;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  font-size: 14px;
  background-color: ${({ disabled, theme }) =>
    disabled ? theme.colors.lightestGray : theme.colors.white};

  ${Label} {
    font-size: 12px;
    transform: translateY(-8px);
  }
`;
